import { useCallback, useEffect, useState } from 'react';

/**
 * Two-step "Clear all" confirmation (ui_specs: destructive clinical actions
 * need one). First activation arms, second executes `onClear`; the armed
 * state resets when the list empties by other means.
 */
export function useConfirmClear(
    itemCount: number,
    onClear: () => void
): { confirming: boolean; requestClear: () => void } {
    const [confirming, setConfirming] = useState(false);

    // Drop the pending confirmation if the list empties by other means.
    useEffect(() => {
        if (itemCount === 0) {
            setConfirming(false);
        }
    }, [itemCount]);

    const requestClear = useCallback(() => {
        if (confirming) {
            onClear();
            setConfirming(false);
        } else {
            setConfirming(true);
        }
    }, [confirming, onClear]);

    return { confirming, requestClear };
}
